import { useCallback } from 'react';

import { EllipsisVerticalIcon, Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Broadcast } from '@/shared/types/broadcast';

type ActionsCellProps = {
  broadcast: Broadcast;
  onDeleteClick?: (broadcast: string) => void;
  canWrite: boolean;
};

const ActionsCell = ({ broadcast, onDeleteClick, canWrite }: ActionsCellProps) => {
  const { t } = useTranslation();

  const handleDelete = useCallback(() => {
    onDeleteClick?.(broadcast.broadcast_id);
  }, [broadcast.broadcast_id, onDeleteClick]);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          variant="ghost-neutral"
          size="icon-sm"
        >
          <EllipsisVerticalIcon size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <DropdownMenuItem
          onSelect={handleDelete}
          disabled={!canWrite}
          variant="destructive"
          className="flex items-center gap-2"
        >
          <Trash2Icon size={16} />
          {`${t('common.delete')}…`}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActionsCell;
